<template>
  <UserContentWrapper
    :title="t('bot.chats')"
    @back="$emit('back')"
    class="user-salon"
  >
    <v-text-field
      v-model="chatName"
      label="Новый чат"
      variant="outlined"
      hint="Введите название чата"
      rounded
      append-icon="mdi-send"
      @click:append="createChat"
    />

    <StateWrapper
      :content="chats"
      :loadingStatus="loadingStatus"
      :checkLogin="true"
    >
      <v-card
        class="mx-auto ma-2"
        variant="outlined"
        v-for="chat in chats"
        :key="chat.id"
        :subtitle="formatDate(chat.createdAt)"
        :title="chat.title"
      >
        <v-card-text>
          <p v-if="chat.history && chat.history.length > 0">
            Чат содержит {{ chat.history.length }} сообщений.
          </p>
          <p v-else>
            Чат еще не содержит сообщений. Для перехода к общению нажмите на кнопку "Открыть".
          </p>
        </v-card-text>

        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            class="text-red-lighten-1 ma-2"
            @click="deleteChat(chat.id)"
          >
            Удалить
          </v-btn>
          <v-btn
            variant="outlined"
            class="text-indigo-lighten-1 ma-2"
            @click="router.push({ path: '/user/bot/' + chat.id })"
          >
            Открыть
          </v-btn>
        </template>
      </v-card>
    </StateWrapper>

    <div class="flex flex__jc-c" v-if="!!data && data.chatsCount">
      <vue-awesome-paginate
        :total-items="data.chatsCount"
        v-model="page"
        :items-per-page="notePerPage"
        :max-pages-shown="maxPagesShown"
        @click="getMyChats"
      />
    </div>

    <div v-if="$route.path === '/user/bot'">
      <AppBackButton :linkMode="true" link="/user/panel" />
    </div>
  </UserContentWrapper>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { t } from '@/utils/translate';
import { usePopupStore } from '@/store/popupStore';
import { useUserStore } from '@/store/userStore';
import { storeToRefs } from 'pinia';
import UserContentWrapper from '@/elements/UserContentWrapper.vue';
import AppBackButton from '@/elements/AppBackButton.vue';
import StateWrapper from '@/components/StateWrapper.vue';
import { botApiUrl } from '@/service/user.service';
import { customAxios } from '@/service/customAxios';
import { capitalizeFirstLetter } from '@/utils/common';

const router = useRouter();
const popupStore = usePopupStore();
const { showPopup } = popupStore;
const userStore = useUserStore();
const { isAdmin } = storeToRefs(userStore);

// Реактивные переменные
const chatName = ref('');
const chats = ref([]);
const loadingStatus = ref('loading');
const data = ref({});
const page = ref(1);
const notePerPage = ref(10);
const maxPagesShown = ref(3);

// Методы
async function createChat() {
  try {
    const res = await customAxios.postExternal(
      botApiUrl + '/api/chat/new',
      { title: chatName.value }
    );
    if (res.status === 201) {
      chatName.value = '';
      router.push({ path: '/user/bot/' + res.data.id });
    }
  } catch (e) {
    if (e.code === 'ERR_NETWORK') {
      showPopup('Бот временно недоступен. Попробуйте позже.', 'error');
    }
    loadingStatus.value = 'error';
  }
}

async function deleteChat(id) {
  try {
    const res = await customAxios.postExternal(
      botApiUrl + '/api/chat/' + id + '/delete',
      {}
    );
    if (res.status === 202) {
      await getMyChats();
    }
  } catch (e) {
    loadingStatus.value = 'error';
  }
}

async function getMyChats() {
 
  try {
    const res = await customAxios.postExternal(
      botApiUrl + '/api/chat',
      {
        page: page.value,
        notePerPage: notePerPage.value,
      }
    );
   
    if (res.status === 200) {
      data.value = res.data;
      chats.value = res.data.chats;
      loadingStatus.value = 'loaded';
    }
  } catch (e) {
    if (e.code === 'ERR_NETWORK') {
      showPopup('Чат временно недоступен. Попробуйте обновить страницу.', 'error');
    }
    console.error(e);
    loadingStatus.value = 'error';
  }
}

// Форматирование даты
function formatDate(dateString) {
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat("ru", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
  return capitalizeFirstLetter(formatter.format(date));
}

// Внешняя логика
watch(() => chatName.value, (newVal) => {
  chatName.value = capitalizeFirstLetter(newVal);
});

onMounted(() => {
  getMyChats();
});
</script>


<style lang="scss">
.user-salon {
  &__menu {
    button + button {
      margin-top: 40px;
    }
  }
}
</style>
